import { get, ref } from 'firebase/database';
import { doc, getDoc } from 'firebase/firestore';

import { NotebookDataType, SheetType } from 'shared/types/notebookTypes';

import { database, firestore } from '../Common/Firebase';

export const getNotebookData = async (userMail?: string, userSubject?: string) => {
  if (userMail && userSubject) {
    const docRef = doc(firestore, 'notebook-content', userMail);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return get(ref(database, `Notebooks/${userMail}/${userSubject}`)).then(response => {
        const mapList: SheetType[] = Object.values(response.val());

        const data: NotebookDataType[] = mapList.map(
          ({ id, isSquared, firstSheet, secondSheet, prevId, nextId, spreadOrder }) => {
            return {
              id,
              isSquared,
              firstContent: {
                content: docSnap.data()[userSubject][id].firstContent,
                isReviewed: firstSheet.isReviewed,
                lastModifiedDate: firstSheet.lastModifiedDate,
                order: firstSheet.order,
                homework: firstSheet.homework,
              },
              secondContent: {
                content: docSnap.data()[userSubject][id].secondContent,
                isReviewed: secondSheet.isReviewed,
                lastModifiedDate: secondSheet.lastModifiedDate,
                order: secondSheet.order,
                homework: secondSheet.homework,
              },
              nextId,
              prevId,
              spreadOrder,
            };
          },
        );

        return data;
      });
    } else {
      console.log('No such document!');
    }
  }
};
